export class Tokens{
    public accessToken!: string;
    public refreshToken!: string;
}